import axios from 'axios'

const Axios = axios.create({
  baseURL: 'https://api.airtable.com/v0/appKm06fM103Z9fGg/Papers'
})

const airtableAPIKey = process.env.VUE_APP_AIRTABLEKEY
Axios.defaults.headers.common = { Authorization: 'Bearer ' + airtableAPIKey }

export default {
  getProjects () {
    return Axios.get('?')
  },
  getProject (slug) {
    return Axios.get("?filterByFormula={slug}='" + slug + "'")
  }
}
